import axios from '@/jslib/axios'

export const getCreditlist = params => {
  return axios({
    method: 'get',
    url: '/admin/credit/list',
    params
  })
}

export const addCreditTransferQueue = data => {
  return axios({
    method: 'post',
    url: '/admin/credit/transfer/queue',
    data
  })
}

export const rejectCreditTransfer = data => {
  return axios({
    method: 'post',
    url: '/admin/credit/transfer/reject',
    data
  })
}

export const getCreditDonelist = params => {
  return axios({
    method: 'get',
    url: '/admin/credit/list/done',
    params
  })
}

export const setCreditDone = data => {
  return axios({
    method: 'post',
    url: '/admin/credit/done',
    data
  })
}

export const removeCreditTransfer = data => {
  return axios({
    method: 'post',
    url: '/admin/credit/transfer/remove',
    data
  })
}

export const getCreditListDownload = params => {
  return axios({
    method: 'get',
    url: '/admin/credit/list/download',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}

export const getCreditDoneListDownload = params => {
  return axios({
    method: 'get',
    url: '/admin/credit/done/download',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}

export const getBanksList = () => {
  return axios({
    method: 'get',
    url: '/admin/card/banks'
  })
}

export const sendSpendingMsg = data => {
  return axios({
    method: 'post',
    url: '/admin/credit/send/spending/mess',
    data
  })
}